/**
 * @generated SignedSource<<c38606e112e1f7d730c43d6b90fb4b3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuestionType = "CHILDREN" | "DATE" | "INPUT" | "MULTI_PUNCH" | "SELECTION";
export type FilteredSurveyInput = {
  PIISurveys?: boolean | null;
  historicSurveys?: boolean | null;
  trackingParams?: ReadonlyArray<TrackingParam | null> | null;
  webcamSurveys?: boolean | null;
};
export type TrackingParam = {
  key: string;
  value: string;
};
export type useDashboardQuery$variables = {
  first?: number | null;
  input: FilteredSurveyInput;
};
export type useDashboardQuery$data = {
  readonly blogPosts: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"BlogPostItem_item">;
      };
    }>;
  } | null;
  readonly consentSettings: {
    readonly " $fragmentSpreads": FragmentRefs<"TermsAndConditionsConsent_consentSettings">;
  } | null;
  readonly deals: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly advertiser: {
          readonly imageUrl: string | null;
          readonly name: string | null;
        } | null;
        readonly description: string | null;
        readonly desktopImageUrl: string | null;
        readonly guid: string;
        readonly id: string;
        readonly imageUrl: string | null;
        readonly paysReward: boolean;
        readonly rewardLabel: string | null;
        readonly tags: ReadonlyArray<string>;
        readonly title: string;
      };
    }>;
  } | null;
  readonly desktopCashbacks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly advertiser: {
          readonly imageUrl: string | null;
          readonly name: string | null;
        } | null;
        readonly description: string | null;
        readonly desktopImageUrl: string | null;
        readonly guid: string;
        readonly id: string;
        readonly imageUrl: string | null;
        readonly paysReward: boolean;
        readonly rewardLabel: string | null;
        readonly tags: ReadonlyArray<string>;
        readonly title: string;
      };
    }>;
  } | null;
  readonly history: {
    readonly cashoutBreakdown: ReadonlyArray<{
      readonly amount: {
        readonly cents: number;
        readonly currency: string;
        readonly formatted: string;
      };
      readonly label: string;
      readonly type: string;
    }> | null;
    readonly earningBreakdown: ReadonlyArray<{
      readonly amount: {
        readonly cents: number;
        readonly currency: string;
        readonly formatted: string;
      };
      readonly label: string;
      readonly type: string;
    }> | null;
    readonly id: string;
    readonly monthlyEarnings: ReadonlyArray<{
      readonly amount: {
        readonly cents: number;
        readonly currency: string;
        readonly formatted: string;
      };
      readonly date: string;
      readonly type: string;
    }> | null;
    readonly status: string;
  } | null;
  readonly notificationSubscriptions: {
    readonly surveyInviteContactChannels: ReadonlyArray<string> | null;
  };
  readonly polls: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly answerTime: number | null;
        readonly description: {
          readonly iconUrl: string | null;
          readonly imageUrl: string | null;
          readonly subtitle: string | null;
          readonly title: string;
        };
        readonly id: string;
        readonly possibleAnswers: {
          readonly answers?: ReadonlyArray<{
            readonly answerKey: string;
            readonly label: string;
          }> | null;
          readonly type: QuestionType;
        } | null;
        readonly responseStatistics: ReadonlyArray<{
          readonly correct: boolean;
          readonly key: string;
          readonly ratio: number;
          readonly selected: boolean;
        }> | null;
        readonly reward: {
          readonly cents: number;
          readonly currency: string;
          readonly formatted: string;
        } | null;
        readonly startDate: string | null;
        readonly userResponse: {
          readonly answerKeys: ReadonlyArray<string | null> | null;
          readonly id: string;
          readonly label: string | null;
        } | null;
      };
    }>;
    readonly id: string;
    readonly pageInfo: {
      readonly totalCount: number | null;
    };
  } | null;
  readonly profilerUrl: string | null;
  readonly signupSurveyUrl: string | null;
  readonly surveys: {
    readonly pageInfo: {
      readonly totalCount: number | null;
    };
  } | null;
  readonly targetRedemptionValue: {
    readonly " $fragmentSpreads": FragmentRefs<"RedeemBanner_target">;
  } | null;
  readonly userData: {
    readonly firstName: string | null;
  } | null;
  readonly walletBalance: {
    readonly amount: {
      readonly currency: string;
      readonly formatted: string;
      readonly subUnitAmount: number;
    };
    readonly " $fragmentSpreads": FragmentRefs<"RedeemBanner_balance">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useMoreSurveysBannerQuery_profileUrlRef" | "useNoSurveysFragmentQuery_noSurveysRef" | "useSurveyListFragmentQuery_surveysRef">;
};
export type useDashboardQuery = {
  response: useDashboardQuery$data;
  variables: useDashboardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subUnitAmount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formatted",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilerUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signupSurveyUrl",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "surveyInviteContactChannels",
  "storageKey": null
},
v10 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "OfferEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Offer",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v11/*: any*/),
        (v12/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        (v13/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "desktopImageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "guid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Advertiser",
          "kind": "LinkedField",
          "name": "advertiser",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            (v13/*: any*/)
          ],
          "storageKey": null
        },
        (v14/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paysReward",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rewardLabel",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = [
  (v15/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v21 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "cents",
    "storageKey": null
  },
  (v3/*: any*/),
  (v4/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "MoneyAmount",
  "kind": "LinkedField",
  "name": "amount",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v23 = [
  (v19/*: any*/),
  (v20/*: any*/),
  (v22/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "History",
  "kind": "LinkedField",
  "name": "history",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "HistoryTotalAmount",
      "kind": "LinkedField",
      "name": "earningBreakdown",
      "plural": true,
      "selections": (v23/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HistoryTotalAmount",
      "kind": "LinkedField",
      "name": "cashoutBreakdown",
      "plural": true,
      "selections": (v23/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HistoryMonthlyAmount",
      "kind": "LinkedField",
      "name": "monthlyEarnings",
      "plural": true,
      "selections": [
        (v24/*: any*/),
        (v19/*: any*/),
        (v22/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answerTime",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconUrl",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "QuestionDescription",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitle",
      "storageKey": null
    },
    (v13/*: any*/),
    (v28/*: any*/)
  ],
  "storageKey": null
},
v30 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SelectionQuestionAnswer",
    "kind": "LinkedField",
    "name": "answers",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "answerKey",
        "storageKey": null
      },
      (v20/*: any*/)
    ],
    "storageKey": null
  }
],
v31 = {
  "kind": "InlineFragment",
  "selections": (v30/*: any*/),
  "type": "SelectionQuestionAnswers",
  "abstractKey": null
},
v32 = {
  "kind": "InlineFragment",
  "selections": (v30/*: any*/),
  "type": "MultiPunchQuestionAnswers",
  "abstractKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "PollResponseStatistic",
  "kind": "LinkedField",
  "name": "responseStatistics",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ratio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "correct",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "selected",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "MoneyAmount",
  "kind": "LinkedField",
  "name": "reward",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "UserQuestionResponse",
  "kind": "LinkedField",
  "name": "userResponse",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "answerKeys",
      "storageKey": null
    },
    (v20/*: any*/)
  ],
  "storageKey": null
},
v36 = [
  (v4/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v37 = [
  (v15/*: any*/),
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useDashboardQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RedeemBanner_balance"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "amount",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AmountDenomination",
        "kind": "LinkedField",
        "name": "targetRedemptionValue",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RedeemBanner_target"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "SurveyConnection",
        "kind": "LinkedField",
        "name": "surveys",
        "plural": false,
        "selections": [
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "args": (v5/*: any*/),
        "kind": "FragmentSpread",
        "name": "useSurveyListFragmentQuery_surveysRef"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "useMoreSurveysBannerQuery_profileUrlRef"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ConsentSettingsConnection",
        "kind": "LinkedField",
        "name": "consentSettings",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TermsAndConditionsConsent_consentSettings"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "useNoSurveysFragmentQuery_noSurveysRef"
      },
      (v7/*: any*/),
      (v8/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationSubscriptions",
        "kind": "LinkedField",
        "name": "notificationSubscriptions",
        "plural": false,
        "selections": [
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "OfferConnection",
        "kind": "LinkedField",
        "name": "deals",
        "plural": false,
        "selections": (v16/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "OfferConnection",
        "kind": "LinkedField",
        "name": "desktopCashbacks",
        "plural": false,
        "selections": (v16/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          (v17/*: any*/)
        ],
        "storageKey": null
      },
      (v25/*: any*/),
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "BlogPostConnection",
        "kind": "LinkedField",
        "name": "blogPosts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BlogPostEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BlogPost",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BlogPostItem_item"
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PollConnection",
        "kind": "LinkedField",
        "name": "polls",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PollEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PollQuestion",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "possibleAnswers",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useDashboardQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "amount",
            "plural": false,
            "selections": (v36/*: any*/),
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AmountDenomination",
        "kind": "LinkedField",
        "name": "targetRedemptionValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "panelistCost",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "redemptionAmount",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "SurveyConnection",
        "kind": "LinkedField",
        "name": "surveys",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SurveyEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Survey",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v14/*: any*/),
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CurrencyAmount",
                    "kind": "LinkedField",
                    "name": "rewardAmount",
                    "plural": false,
                    "selections": (v36/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MoneyAmount",
                    "kind": "LinkedField",
                    "name": "baseReward",
                    "plural": false,
                    "selections": (v21/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LockedSurveyInfo",
                    "kind": "LinkedField",
                    "name": "lockedInfo",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "supportId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DurationDetails",
                    "kind": "LinkedField",
                    "name": "durationDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "providerDuration",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "studyId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AdminSurveyData",
                    "kind": "LinkedField",
                    "name": "adminData",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rankScore",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "surveyGuid",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "statusDescription",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "surveyId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startedAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endlessProfilerUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "demographicProfileUrl",
        "storageKey": null
      },
      (v7/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileCompletion",
        "kind": "LinkedField",
        "name": "profileCompletionPercentage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileCompletionPercentage",
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ConsentSettingsConnection",
        "kind": "LinkedField",
        "name": "consentSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentVersion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "consentedVersion",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationSubscriptions",
        "kind": "LinkedField",
        "name": "notificationSubscriptions",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      },
      (v8/*: any*/),
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "OfferConnection",
        "kind": "LinkedField",
        "name": "deals",
        "plural": false,
        "selections": (v37/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "OfferConnection",
        "kind": "LinkedField",
        "name": "desktopCashbacks",
        "plural": false,
        "selections": (v37/*: any*/),
        "storageKey": null
      },
      (v25/*: any*/),
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "BlogPostConnection",
        "kind": "LinkedField",
        "name": "blogPosts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BlogPostEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BlogPost",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "excerpt",
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PollConnection",
        "kind": "LinkedField",
        "name": "polls",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PollEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PollQuestion",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "possibleAnswers",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v19/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b8180dd7a8e174897c68d585921c456b",
    "id": null,
    "metadata": {},
    "name": "useDashboardQuery",
    "operationKind": "query",
    "text": "query useDashboardQuery(\n  $input: FilteredSurveyInput!\n  $first: Int\n) {\n  walletBalance {\n    ...RedeemBanner_balance\n    amount {\n      subUnitAmount\n      currency\n      formatted\n    }\n    id\n  }\n  targetRedemptionValue {\n    ...RedeemBanner_target\n  }\n  surveys(input: $input) {\n    pageInfo {\n      totalCount\n    }\n    id\n  }\n  ...useSurveyListFragmentQuery_surveysRef_2VV6jB\n  ...useMoreSurveysBannerQuery_profileUrlRef\n  consentSettings {\n    ...TermsAndConditionsConsent_consentSettings\n  }\n  ...useNoSurveysFragmentQuery_noSurveysRef\n  profilerUrl\n  signupSurveyUrl\n  notificationSubscriptions {\n    surveyInviteContactChannels\n    id\n  }\n  deals(first: $first) {\n    edges {\n      node {\n        id\n        title\n        description\n        imageUrl\n        desktopImageUrl\n        guid\n        advertiser {\n          name\n          imageUrl\n        }\n        tags\n        paysReward\n        rewardLabel\n      }\n    }\n    id\n  }\n  desktopCashbacks(first: $first) {\n    edges {\n      node {\n        id\n        title\n        description\n        imageUrl\n        desktopImageUrl\n        guid\n        advertiser {\n          name\n          imageUrl\n        }\n        tags\n        paysReward\n        rewardLabel\n      }\n    }\n    id\n  }\n  userData {\n    firstName\n    id\n  }\n  history {\n    id\n    status\n    earningBreakdown {\n      type\n      label\n      amount {\n        cents\n        currency\n        formatted\n      }\n    }\n    cashoutBreakdown {\n      type\n      label\n      amount {\n        cents\n        currency\n        formatted\n      }\n    }\n    monthlyEarnings {\n      date\n      type\n      amount {\n        cents\n        currency\n        formatted\n      }\n    }\n  }\n  blogPosts(first: $first) {\n    edges {\n      node {\n        ...BlogPostItem_item\n        id\n      }\n    }\n  }\n  polls {\n    id\n    pageInfo {\n      totalCount\n    }\n    edges {\n      node {\n        id\n        startDate\n        answerTime\n        description {\n          title\n          subtitle\n          imageUrl\n          iconUrl\n        }\n        possibleAnswers {\n          __typename\n          type\n          ... on SelectionQuestionAnswers {\n            answers {\n              answerKey\n              label\n            }\n          }\n          ... on MultiPunchQuestionAnswers {\n            answers {\n              answerKey\n              label\n            }\n          }\n        }\n        responseStatistics {\n          key\n          ratio\n          correct\n          selected\n        }\n        reward {\n          cents\n          currency\n          formatted\n        }\n        userResponse {\n          id\n          answerKeys\n          label\n        }\n      }\n    }\n  }\n}\n\nfragment BlogPostItem_item on BlogPost {\n  title\n  imageUrl\n  excerpt\n  date\n  slug\n}\n\nfragment PushNotificationsCardFragment_notificationSubscriptions on NotificationSubscriptions {\n  surveyInviteContactChannels\n}\n\nfragment RedeemBanner_balance on WalletBalance {\n  amount {\n    formatted\n    subUnitAmount\n  }\n  id\n}\n\nfragment RedeemBanner_target on AmountDenomination {\n  panelistCost {\n    subUnitAmount\n  }\n  redemptionAmount {\n    formatted\n  }\n}\n\nfragment TermsAndConditionsConsent_consentSettings on ConsentSettingsConnection {\n  currentVersion\n  consentedVersion\n}\n\nfragment useFinishedSurveyCardFragmentQuery_surveyRef on Survey {\n  id\n  title\n  status\n  statusDescription\n  supportId\n  surveyId\n  studyId\n  tags\n  startedAt\n  rewardAmount {\n    formatted\n  }\n  durationDetails {\n    providerDuration\n  }\n}\n\nfragment useMoreSurveysBannerQuery_profileUrlRef on Query {\n  endlessProfilerUrl\n  demographicProfileUrl\n  profilerUrl\n  profileCompletionPercentage {\n    profileCompletionPercentage\n    id\n  }\n  userData {\n    firstName\n    id\n  }\n}\n\nfragment useNoSurveysFragmentQuery_noSurveysRef on Query {\n  endlessProfilerUrl\n  profilerUrl\n  userData {\n    firstName\n    id\n  }\n  notificationSubscriptions {\n    ...PushNotificationsCardFragment_notificationSubscriptions\n    id\n  }\n}\n\nfragment useSurveyCardFragmentQuery_surveyRef on Survey {\n  id\n  iconUrl\n  rewardAmount {\n    formatted\n    subUnitAmount\n    currency\n  }\n  baseReward {\n    cents\n    currency\n    formatted\n  }\n  lockedInfo {\n    title\n  }\n  title\n  url\n  status\n  supportId\n  durationDetails {\n    providerDuration\n  }\n  tags\n  studyId\n  adminData {\n    rankScore\n    surveyGuid\n  }\n}\n\nfragment useSurveyListFragmentQuery_surveysRef_2VV6jB on Query {\n  surveys(input: $input) {\n    pageInfo {\n      totalCount\n    }\n    edges {\n      node {\n        id\n        tags\n        status\n        url\n        ...useSurveyCardFragmentQuery_surveyRef\n        ...useFinishedSurveyCardFragmentQuery_surveyRef\n      }\n    }\n    id\n  }\n  userData {\n    firstName\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d2e42264a0a81fb51377db2676312e53";

export default node;
